/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, serializeAllotmentReportCreateRequest, type AllotmentReportCreateRequest, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /AllotmentReport/CreateForTourOperator
 */
export interface CreateForTourOperatorRequestBuilder extends BaseRequestBuilder<CreateForTourOperatorRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<number>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AllotmentReportCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<number | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AllotmentReportCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CreateForTourOperatorRequestBuilderUriTemplate = "{+baseurl}/AllotmentReport/CreateForTourOperator";
/**
 * Metadata for all the requests in the request builder.
 */
export const CreateForTourOperatorRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CreateForTourOperatorRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "number",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAllotmentReportCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
